(function () {
  document.querySelectorAll('.nt-header').forEach(function (header) {
    var id = header.id.replace('nt-header-', '');
    var drawer = document.getElementById('nt-mobile-drawer-' + id);
    var toggles = document.querySelectorAll('[data-nt-drawer-toggle]');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (!drawer) return;
        var isHidden = drawer.hasAttribute('hidden');
        if (isHidden) {
          drawer.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
        } else {
          drawer.setAttribute('hidden', '');
          document.body.style.overflow = '';
        }
      });
    });

    if (header.classList.contains('nt-header--transparent')) {
      var onScroll = function () {
        if (window.scrollY > 40) {
          header.classList.add('nt-header--is-scrolled');
        } else {
          header.classList.remove('nt-header--is-scrolled');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });
})();
